import { RelayEnvironmentProvider } from 'react-relay'
import { RouterProvider } from 'react-router5'

import 'web-client/utils/rollbarConfigure'
import enforceSiteUrl from 'web-client/utils/enforceSiteUrl'
import relayService from 'shared/utils/relay'
// eslint-disable-next-line no-restricted-imports -- use datadog and rollbar directly
import logging from 'shared/utils/logging'
import GlobalErrorBoundary from 'shared/components/ErrorBoundary/Global'
import GlobalStyles from 'design-system/components/GlobalStyles'
import setupFontAwesomeLibrary from 'design-system/tokens/fontAwesome'
import userService from 'shared/utils/user'
import EnvironmentIndicator from 'web-client/components/EnvironmentIndicator'
import { SwoopVersionProvider } from 'web-client/hooks/useSwoopVersion'
import lazyRetry from 'shared/utils/lazyRetry'
import renderToDOM from 'shared/applicationRenderer'
import routes from './routes'
import createRouter from './create-router'

const LazyLoader = lazyRetry(() => import('web-client/router/LazyLoaderSplit'))

enforceSiteUrl()

setupFontAwesomeLibrary()

userService.maintainSession(relayService.environment)

const router = createRouter(routes)

router.useMiddleware((_) => (toState, fromState, done) => {
  const route = routes.find(({ name }) => name === toState.name)

  if (route && 'beforeRender' in route) {
    if (typeof route.beforeRender !== 'function') {
      logging.logError("route's `beforeRender` should be a function", { route })
      done()
      return
    }

    void route.beforeRender(router, done, toState)
    return
  }

  done()
})
router.start((error) => {
  if (error) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- router error type is untyped
    logging.logError(error)
  }
  renderToDOM(
    <GlobalErrorBoundary>
      <GlobalStyles />
      <RelayEnvironmentProvider environment={relayService.environment}>
        <EnvironmentIndicator />
        <RouterProvider router={router}>
          <SwoopVersionProvider>
            <LazyLoader />
          </SwoopVersionProvider>
        </RouterProvider>
      </RelayEnvironmentProvider>
    </GlobalErrorBoundary>
  )
})
